<template>
	<div>
		<div class="login_bg">
			<div class="registerSuccess" v-if="registerStatic">
				<i class="el-icon-success"></i>
				<div class="tips">
					注册成功！去<router-link to="/login">登录</router-link>
				</div>
			</div>
			<div class="login_con" v-else>
				<div v-if="registerFirst">
					<el-form :model="registForm" ref="registForms" :rules="rules">
						<h2 class="reset_h2">注册</h2>
						<el-form-item class="go_login" v-if="loginStatus">
							<i class="el-icon-warning"></i>
							账号已注册，你可以去
							<router-link to="/login">登录</router-link>
						</el-form-item>
						<el-form-item prop="phone">
							<el-input placeholder="手机号" maxlength="11" v-model.trim="registForm.phone"></el-input>
						</el-form-item>
						<el-form-item>
							<loadsolid v-model="isLock" @change="handlerLock"></loadsolid>
						</el-form-item>
						<el-form-item prop="code">
							<div class="code_box">
								<el-input type="text" maxlength="6" placeholder="验证码" v-model.trim="registForm.code"
									autocomplete="off">
								</el-input>
								<el-button :disabled="codeDis||registForm.phone.length!==11" type="" class="code_btn"
									@click="getPhone" v-if="codeStatus">
									获取验证码</el-button>
								<el-button class="code_btn" v-else disabled>重发{{ codeTime }}s
								</el-button>
							</div>
						</el-form-item>
						<el-form-item prop="password" class="m_bottom_0">
							<el-input show-password type="password" placeholder="8-20位密码"
								v-model.trim="registForm.password" autocomplete="off">
							</el-input>
						</el-form-item>
						<div class="reg_box">
							已有账号！<router-link to="/login">去登录</router-link>
						</div>

						<el-form-item class="">
							<el-button type="primary"
								:disabled="!isLock ||registForm.code=='' || registForm.password.length<8 || !argees"
								class="registerbtn" @click="getName">注册</el-button>
						</el-form-item>
						<div>
							<el-checkbox v-model="argees">我已阅读并接受</el-checkbox>
							<span class="re_f_tip" @click="argClick('footagree','用户协议')">《<span>用户协议</span>》</span>
							<span class="re_f_tip1">和</span>
							<span class="re_f_tip" @click="argClick('footpolicy','隐私政策')">《<span>隐私政策</span>》</span>
						</div>
					</el-form>
				</div>
				<div v-else>
					<div>
						<el-input maxlength="8" show-word-limit placeholder="给自己起个好听的名字吧" v-model.trim="userName"></el-input>
					</div>
					<div class="mt20">
						<el-button type="success" class="registerbtn" @click="nameSure" :disabled="userName==''">
							确 定</el-button>
					</div>
					<div class="mt20">
						<el-popover ref='popover' placement="bottom" width="300" trigger="click" popper-class="skipcon">
							<div class="pad20">
								<div>
									<i class="el-icon-alarm-clock"></i>
									<span class="d-gray">跳过后系统随机生成用户名：</span>

									<h2 class="username u-text-center mt10">{{sysName}}</h2>
								</div>
								<div class="mt20 u-text-center">
									<el-button @click="sureRegister">确认跳过</el-button>
									<el-button type="primary" @click="noSkip">不跳过</el-button>
								</div>
							</div>
							<el-button slot="reference" type="success" class="registerbtn ">跳 过
							</el-button>
						</el-popover>
					</div>
				</div>
			</div>
		</div>
		<FooterCopy></FooterCopy>
	</div>
</template>

<script>
	import loadsolid from '../../components/LoginSolid.vue'
	import FooterCopy from '../../components/FooterCopy.vue'
	export default {
		name: 'forgot',
		components: {
			loadsolid,
			FooterCopy
		},
		data() {
			var validpassword = (rule, value, callback) => {
				let reg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,20}$/
				if (!value) {
					callback(new Error('密码不能为空'));
				} else {
					if (reg.test(value)) {
						callback();
					} else {
						callback(new Error('8-20位密码，必须包含字母/数字'));
					}
				}
			};
			var validCode = (rule, value, callback) => {
				if (value.length < 6) {
					callback(new Error('验证码不能少于6位'));
				} else {
					callback();
				}
			};

			var validphone = (rule, value, callback) => {
				const mailReg = /^1[3-9]\d{9}$/;
				if (!value) {
					callback(new Error('请输入手机号'));
				} else {
					if (mailReg.test(value)) {
						callback();
					} else {
						callback(new Error('手机号错误'));
					}
				}
			};
			return {
				//系统默认名
				sysName: '',
				userName: '',
				//滑块
				isLock: false,
				//是否登录
				registerStatic: false,
				//去输入用户名
				registerFirst: true,
				//滑动状态
				codeDis: true,
				//是否勾选
				argees: false,
				//获取验证码状态
				codeStatus: true,
				//验证码时间
				codeTime: 60,
				registForm: {
					name: '',
					phone: '',
					password: '',
					code: '',
				},
				rules: {
					password: [{
						validator: validpassword,
						trigger: 'blur',
						required: true,
					}],

					code: [{
						validator: validCode,
						trigger: 'blur',
						required: true,
					}],
					phone: [{
						validator: validphone,
						trigger: 'blur',
						required: true,
					}]
				},
				//是否去登录
				loginStatus: false,
				//倒计时
				timer: null
			};
		},
		created() {

		},
		methods: {
			//获取验证码1
			getPhone() {
				this.loginStatus = false
				this.$axios.get('/front/login/checkPhoneRegister', {
					phone: this.registForm.phone
				}).then((res) => {
					if (res.code == 200) {
						this.getCode();
						this.codeStatus = false;
						this.timer = setInterval(() => {
							if (this.codeTime > 1 && this.codeTime <= 60) {
								this.codeTime--;
							} else {
								this.codeTime = 60;
								this.codeStatus = true;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000);
						return
					}
					if (res.code == 402) {
						this.$msg.error('手机号已注册')
						this.loginStatus = true
						return
					}
				})
			},
			//获取验证码2
			getCode() {
				this.$axios.post('/front/login/sendSmsCode', {
					'login': this.registForm.phone
				}).then((res) => {
					if (res.code == 200) this.$msg.success('验证码已发送')
					// this.registForm.code = res.data
				})
			},
			getName() {
				if (!this.argees) {
					this.$msg.error('请勾选隐私政策和用户协议')
				} else {
					this.$axios.post('/front/login/getUserName', {
						"login": this.registForm.phone,
						"loginType": 0,
						"password": this.registForm.password,
						"smsCode": this.registForm.code
					}).then((res) => {
						if (res.code == 200) {
							this.sysName = res.data;
							this.registerFirst = !this.registerFirst
						}
					})
				}
			},

			//提交表单
			submitForm() {
				this.$axios.post('/front/login/register', {
					"login": this.registForm.phone,
					"loginType": 0,
					"password": this.registForm.password,
					"smsCode": this.registForm.code,
					"userName": this.registForm.name
				}).then((res) => {
					if (res.code == 200) {
						this.$msg.success('注册成功')
						this.registerStatic = !this.registerStatic
					}
				})
			},
			//滑动监听
			handlerLock(data) {
				if (data) {
					this.isLock = true;
					this.codeDis = false
				}
			},
			//不跳过
			noSkip() {
				this.$refs.popover.doClose()
			},

			//用户名确定
			nameSure() {
				//输入的用户名
				this.registForm.name = this.userName;
				//提交表单
				this.submitForm()
				this.$refs.popover.doClose()
			},
			//确定跳过并获取系统用户名
			sureRegister() {
				//获取系统用户名
				this.registForm.name = this.sysName;
				//提交表单
				this.submitForm()
			},
			argClick(path, v) {
				this.$router.push({
					name: path,
					query: {
						service: v
					}
				})
			}
		}
	};
</script>

<style lang="scss" scoped>
	/deep/ .el-checkbox__input.is-checked + .el-checkbox__label{
		color: #606266;
	}
	.re_f_tip {
		color: var(--brand);
		cursor: pointer;

		span {
			&:hover {
				text-decoration: underline;
			}
		}
	}

	.re_f_tip1 {
		color: #606266;
	}

	.reg_box {
		text-align: right;
		line-height: 34px;
		padding: 4px 0 14px 0;
		color: var(--info);

		a {
			color: var(--brand);
		}

	}

	.reset_h2 {
		margin-bottom: 20px;
	}

	.m_bottom_0 {
		margin-bottom: 0;
	}

	.login_bg {
		position: fixed;
		z-index: 2;
		// background: url("../../assets/image/login/login-tommyp.jpg") no-repeat;
		background-size: cover;
		width: 100%;
		height: 100%;

		.login_con {
			width: 340px;
			margin: 12% auto 0 auto;
			border-radius: 10px;
			padding: 30px;
			background-color: white;
		}
	}

	.code_box {
		display: flex;
	}

	.code_btn {
		width: 140px;
		margin-left: 20px;
	}

	.go_login {
		border-radius: 3px;
		padding-left: 14px;
		background-color: #ffe0e0;
		color: var(--info);

		a {
			color: var(--brand);
			display: inline-block;
			margin-left: 2px;
		}
	}

	.registerbtn {
		width: 100%;
	}

	.username {
		color: var(--brand);
	}

	.registerSuccess {
		margin: 20vh auto 0 auto;
		text-align: center;
		background-color: white;
		padding: 100px 0;
		border-radius: 10px;
		width: 800px;

		i {
			margin-bottom: 10px;
			color: var(--brand);
			font-size: 120px;
		}

		.tips {
			color: var(--info);

			a {
				color: var(--brand);
			}
		}

	}
</style>
